import * as React from 'react';
import {
  IProcess,
  IDelprocess,
  IProcessAktivitetFlode,
} from '../../Types/ProcessModel';
import ProcessesHeader from './Components/ProcessesHeader/ProcessesHeader';
import SubprocessHeader from './Components/SubprocessesHeader/SubprocessesHeader';
import ActivityFlowsHeader from './Components/ActivityFlowsHeader/ActivityFlowsHeader';
import ProcessPage from './Components/ProcessPage/ProcessPage';
import SubprocessPage from './Components/SubprocessPage/SubprocessPage';
import ActivityFlowPage from './Components/ActivityFlowPage/ActivityFlowPage';
import { SelectProcessPage } from './Components/SelectProcessPage/SelectProcessPage';
import { IProcessButton } from './Components/ProcessButtons/ProcessButtons';
import { ProcessModel } from '../../Model/ProcessModel/ProcessModel';
import { IProcessWarning } from './Components/ProcessHeaderBase/ProcessHeaderBase';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary';
import {
  LoginStateContext,
  IDatabase,
} from '../Login/Contexts/LoginStateContext/LoginStateContext';

interface IProps {}

interface IInnerProps extends IProps {
  databases: IDatabase[];
}

interface IState {
  selectedProcess?: IProcess;
  selectedSubprocess?: IDelprocess;
  selectedActivityFlow?: IProcessAktivitetFlode;
  selectedDatabases: IDatabase[];
}

// TODO: Ska ej hårdkodas
const warnings: IProcessWarning[] = [
  {
    database: 'Nystad Pastorat',
    process: '3',
    subProcess: '3.1',
    activityFlow: '3.1.1',
    activity: 7,
    message:
      'Det finns fakturor som har väntat mer än två dagar på att bokföras',
  },
];

export class ProcessesPage extends React.Component<IInnerProps, IState> {
  state: IState = {
    selectedDatabases: [],
    selectedProcess: ProcessModel.Processer[0],
  };

  onProcessSelected = (selectedButton: IProcessButton) => {
    this.setState({
      selectedProcess:
        this.state.selectedProcess &&
        this.state.selectedProcess.Kod === selectedButton.Kod
          ? undefined
          : ProcessModel.Processer.find(x => x.Kod === selectedButton.Kod),
      selectedSubprocess: undefined,
      selectedActivityFlow: undefined,
    });
  };

  onSubprocessSelected = (selectedButton: IProcessButton) => {
    this.setState({
      selectedSubprocess:
        !this.state.selectedProcess ||
        (this.state.selectedSubprocess &&
          this.state.selectedSubprocess.Kod === selectedButton.Kod)
          ? undefined
          : this.state.selectedProcess.Delprocesser.find(
              x => x.Kod === selectedButton.Kod
            ),
      selectedActivityFlow: undefined,
    });
  };

  onActivityFlowSelected = (selectedButton: IProcessButton) => {
    this.setState({
      selectedActivityFlow:
        !this.state.selectedProcess ||
        !this.state.selectedSubprocess ||
        (this.state.selectedActivityFlow &&
          this.state.selectedActivityFlow.Kod === selectedButton.Kod)
          ? undefined
          : this.state.selectedSubprocess.Aktivitetsfloden.find(
              x => x.Kod === selectedButton.Kod
            ),
    });
  };

  onSelectDatabase = (database: IDatabase) => {
    const filteredDatabases = this.state.selectedDatabases.filter(
      db => db.id !== database.id
    );

    const wasSelected =
      filteredDatabases.length !== this.state.selectedDatabases.length;

    if (wasSelected) {
      this.setState({ selectedDatabases: filteredDatabases });
    } else {
      this.setState({
        selectedDatabases: [...this.state.selectedDatabases, database],
      });
    }
  };

  render() {
    const showWarnings = warnings.filter(w =>
      this.state.selectedDatabases.find(
        db => db.name.toLocaleLowerCase() === w.database.toLocaleLowerCase()
      )
    );
    return (
      <ErrorBoundary name="Processer">
        <div style={{ width: '100%' }}>
          <ProcessesHeader
            selectedProcess={this.state.selectedProcess}
            onProcessSelected={this.onProcessSelected}
            databases={this.props.databases}
            selectedDatabases={this.state.selectedDatabases}
            onSelectDatabase={this.onSelectDatabase}
            minimized={!!this.state.selectedSubprocess}
            warnings={showWarnings}
            allWarnings={warnings}
          />
          {this.state.selectedProcess && (
            <SubprocessHeader
              selectedSubProcess={this.state.selectedSubprocess}
              subprocesses={this.state.selectedProcess.Delprocesser}
              onSubprocessSelected={this.onSubprocessSelected}
              truncated={!!this.state.selectedActivityFlow}
              warnings={showWarnings}
            />
          )}
          {this.state.selectedSubprocess && (
            <ActivityFlowsHeader
              selectedActivityFlow={this.state.selectedActivityFlow}
              activityFlows={this.state.selectedSubprocess.Aktivitetsfloden}
              onActivityFlowSelected={this.onActivityFlowSelected}
              warnings={showWarnings}
            />
          )}
          {!this.state.selectedProcess && (
            <SelectProcessPage onProcessSelected={this.onProcessSelected} />
          )}
          {this.state.selectedProcess && !this.state.selectedSubprocess && (
            <ProcessPage process={this.state.selectedProcess} />
          )}
          {this.state.selectedSubprocess &&
            !this.state.selectedActivityFlow && (
              <SubprocessPage subprocess={this.state.selectedSubprocess} />
            )}
          {this.state.selectedActivityFlow && (
            <ActivityFlowPage
              activityFlow={this.state.selectedActivityFlow}
              warnings={showWarnings}
            />
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

/**
 *  Sidvyn för Processer rutinen
 */
const EnhancedProcessesPage: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = () => {
  const { databases } = React.useContext(LoginStateContext);
  return <ProcessesPage databases={databases} />;
};

export default EnhancedProcessesPage;
